import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import loadCommunityUsers from '../service/userDirectoryApi';
export default class UserDirectoryPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.users = [];
    this.loading = true;
    loadCommunityUsers().then(response => {
      this.users = response.data || [];
    }).catch(() => {
      this.users = [];
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Участники DevConnect');
  }
  view() {
    return m('main.dc-users', {
      'aria-labelledby': 'dc-users-title'
    }, [m('section.dc-users__hero', m('div.dc-container', [m('span', 'Сообщество DevConnect'), m('h1#dc-users-title', 'Участники'), m('p', 'Люди, которые задают понятные вопросы, делятся рабочими решениями и помогают другим разработчикам.')])), m('section.dc-container.dc-users__grid', this.content())]);
  }
  content() {
    if (this.loading) {
      return m('div.dc-users__empty', 'Загружаем участников…');
    }
    if (!this.users.length) {
      return m('div.dc-users__empty', 'Подтверждённые участники появятся после первых публикаций.');
    }
    return this.users.map((user, index) => m('article.dc-user-card', [m('span.dc-user-card__rank', index + 1), user.avatarUrl ? m('img', {
      src: user.avatarUrl,
      alt: '',
      loading: 'lazy'
    }) : m('span.dc-user-card__avatar', {
      'aria-hidden': 'true'
    }, (user.displayName || '?').slice(0, 1).toLocaleUpperCase('ru-RU')), m('div.dc-user-card__identity', [m('h2', m('a', {
      href: user.url
    }, user.displayName)), m('p', user.online ? 'Сейчас на сайте' : `@${user.username}`)]),
    // Метрики подписаны явно: цвет и позиция не являются единственным способом понять рейтинг.
    m('dl', [this.metric('Репутация', user.reputation), this.metric('Темы', user.discussions), this.metric('Ответы', user.comments)])]));
  }
  metric(label, value) {
    return m('div', [m('dt', label), m('dd', value)]);
  }
}
flarum.reg.add('devconnect-community', 'forum/components/UserDirectoryPage', UserDirectoryPage);